import Vue from "vue";
import ApiService from "../../services/ApiService";

Vue.component("fan-badge-welcome", {
  delimiters: ["${", "}"],

  data() {
    return {
      isVisible: false,
      isLoading: true,
      badgeInfo: null,
      isLoggedIn: false,
      showUpgradeAnimation: false,
      justUpgraded: false
    };
  },

  computed: {
    currentBadgeTitle() {
      if (!this.badgeInfo || !this.badgeInfo.currentBadge) {
        return "Fanliebling-Fan";
      }
      return this.badgeInfo.currentBadge.title;
    },

    currentBadgeColor() {
      if (!this.badgeInfo || !this.badgeInfo.currentBadge) {
        return "#8B7355";
      }
      return this.badgeInfo.currentBadge.color;
    },

    nextBadgeTitle() {
      if (!this.badgeInfo || !this.badgeInfo.nextBadge) {
        return "";
      }
      return this.badgeInfo.nextBadge.title;
    },

    progressPercentage() {
      if (!this.badgeInfo || !this.badgeInfo.progress) {
        return 0;
      }
      return this.badgeInfo.progress.percentage;
    },

    progressText() {
      if (!this.badgeInfo || !this.badgeInfo.progress) {
        return "0 von 1";
      }
      return `${this.badgeInfo.progress.current} von ${this.badgeInfo.progress.total}`;
    },

    remainingInteractions() {
      if (!this.badgeInfo || !this.badgeInfo.progress) {
        return 1;
      }
      return this.badgeInfo.progress.remaining;
    },

    hasNextLevel() {
      return this.badgeInfo && this.badgeInfo.hasNextLevel;
    },

    motivationalText() {
      if (!this.badgeInfo) {
        return "Deine Stimme zählt.";
      }

      const count = this.badgeInfo.interactionCount;

      if (count === 0) {
        return "Werde Teil unserer Community.";
      } else if (count === 1) {
        return "Großartig! Deine erste Interaktion.";
      } else if (count < 10) {
        return "Deine Stimme zählt.";
      } else if (count < 50) {
        return "Du bist auf einem tollen Weg!";
      } else if (count < 100) {
        return "Du gehörst zu den aktivsten Fans.";
      } else {
        return "Du bist eine Legende in unserer Community!";
      }
    },

    // CSS Custom Properties für Badge-Farben (Dark/Light Mode kompatibel)
    badgeColorStyle() {
      const color = this.currentBadgeColor;
      // Bestimme welche vordefinierte CSS-Variable verwendet wird
      const cssVarMap = {
        "#8B7355": "--badge-color-fan",       // Fanliebling-Fan
        "#CD7F32": "--badge-color-insider",   // Fan-Insider
        "#C0C0C0": "--badge-color-beobachter", // Spielbeobachter
        "#FFD700": "--badge-color-leader"     // Tribünen-Leader
      };
      
      const cssVar = cssVarMap[color] || "--badge-color-fan";
      
      return {
        "--badge-current-color": `var(${cssVar})`,
        "--badge-color-bg": `var(${cssVar})`,
        "--badge-color-border": `var(${cssVar})`
      };
    }
  },

  created() {    
  },

  mounted() {    
    // Only run in browser, not during SSR
    if (typeof window === "undefined") {
      return;
    }

    // Load badge info first
    this.checkLoginAndLoadBadge();

    // Prüfe ob User gerade eingeloggt hat
    const justLoggedIn = sessionStorage.getItem("fl_just_logged_in");
    if (justLoggedIn === "true") {
      sessionStorage.removeItem("fl_just_logged_in");
      this.showWelcomeModal();
    }

    // Prüfe auf Badge-Upgrade
    this.checkForBadgeUpgrade();
  },

  methods: {
    checkLoginAndLoadBadge() {
      // Prüfe Login-Status
      if (this.$store && this.$store.state && this.$store.state.user) {
        this.isLoggedIn = !!this.$store.state.user.isLoggedIn;
      }

      if (this.isLoggedIn) {
        this.loadBadgeInfo();
      } else {
        this.isLoading = false;
      }
    },

    loadBadgeInfo() {
      this.isLoading = true;

      ApiService.get("/rest/fanliebling/badge/user")
        .done((response) => {
          if (response.success) {
            this.badgeInfo = response.data;
          }
          this.isLoading = false;
        })
        .fail((error) => {
          console.error("Error loading badge info:", error);
          this.isLoading = false;
        });
    },

    showWelcomeModal() {
      if (this.isLoggedIn && !this.isLoading) {
        this.isVisible = true;
      }
    },

    closeModal() {
      this.isVisible = false;
    },

    goToVote() {
      this.closeModal();
      // Scrolle zur Vote-Widget Position oder navigiere zur Voting-Seite
      const voteWidget = document.querySelector(".vote-widget");
      if (voteWidget) {
        voteWidget.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    checkForBadgeUpgrade() {
      // Prüfe ob ein Badge-Upgrade im Session Storage gespeichert ist
      const upgradeInfo = sessionStorage.getItem("fl_badge_upgrade");
      if (upgradeInfo) {
        try {
          const upgrade = JSON.parse(upgradeInfo);
          sessionStorage.removeItem("fl_badge_upgrade");
          this.showUpgradeNotification(upgrade);
        } catch (e) {
          console.error("Error parsing badge upgrade info:", e);
        }
      }
    },

    showUpgradeNotification(upgrade) {
      this.justUpgraded = true;
      this.showUpgradeAnimation = true;

      // Animation nach 5 Sekunden ausblenden
      setTimeout(() => {
        this.showUpgradeAnimation = false;
        setTimeout(() => {
          this.justUpgraded = false;
        }, 500);
      }, 5000);
    }
  },

  render: function(h) {
    if (!this.isVisible) {
      return null;
    }

    return h("div", {
      class: "modal fade show",
      style: { display: "block" },
      attrs: {
        tabindex: "-1",
        role: "dialog"
      }
    }, [
      h("div", { class: "modal-dialog modal-dialog-centered" }, [
        h("div", { class: "modal-content" }, [
          // Modal Header
          h("div", { 
            class: "modal-header",
            style: { 
              background: `linear-gradient(135deg, ${this.currentBadgeColor} 0%, ${this.currentBadgeColor}dd 100%)`,
              color: "white"
            }
          }, [
            h("h5", { class: "modal-title" }, "Willkommen zurück!"),
            h("button", {
              class: "close text-white",
              attrs: { type: "button" },
              on: { click: this.closeModal }
            }, [
              h("span", { attrs: { "aria-hidden": "true" } }, "×")
            ])
          ]),

          // Modal Body
          h("div", { class: "modal-body text-center py-4" }, [
            // Loading State
            this.isLoading
              ? h("div", { class: "text-center py-5" }, [
                  h("i", { class: "fa fa-spinner fa-spin fa-3x mb-3" }),
                  h("p", {}, "Lade deine Badge-Daten...")
                ])
              : [
                  // Badge Icon
                  h("div", { class: "mb-3" }, [
                    h("i", { 
                      class: "fa fa-star fa-4x",
                      style: { color: this.currentBadgeColor }
                    })
                  ]),

                  // Badge Title
                  h("h4", { 
                    class: "mb-3",
                    style: { color: this.currentBadgeColor }
                  }, this.currentBadgeTitle),

                  // Motivational Text
                  h("p", { class: "lead mb-4" }, this.motivationalText),

                  // Progress Section
                  this.hasNextLevel
                    ? h("div", { class: "progress-section mb-4" }, [
                        h("p", { class: "mb-2" }, [
                          "Noch ",
                          h("strong", {}, this.remainingInteractions),
                          " Interaktionen bis ",
                          h("strong", {}, this.nextBadgeTitle)
                        ]),
                        h("div", { class: "progress", style: { height: "20px" } }, [
                          h("div", {
                            class: "progress-bar progress-bar-striped progress-bar-animated",
                            style: {
                              width: `${this.progressPercentage}%`,
                              backgroundColor: this.currentBadgeColor
                            },
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": this.progressPercentage,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }
                          }, `${this.progressPercentage}%`)
                        ])
                      ])
                    : h("p", { class: "text-success mb-4" }, [
                        h("i", { class: "fa fa-trophy mr-2" }),
                        "Du hast das höchste Level erreicht!"
                      ])
                ]
          ]),

          // Modal Footer
          h("div", { class: "modal-footer" }, [
            h("button", {
              class: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: this.closeModal }
            }, "Schließen"),
            h("button", {
              class: "btn btn-custom",
              attrs: { type: "button" },
              style: { backgroundColor: this.currentBadgeColor, color: "white" },
              on: { click: this.goToVote }
            }, "Jetzt mitmachen")
          ])
        ])
      ]),

      // Modal Backdrop
      h("div", { 
        class: "modal-backdrop fade show",
        on: { click: this.closeModal }
      })
    ]);
  }
});
